// An exercise response is the student's own writing, and until Submit lands
// it exists nowhere but the textarea. Anything that unmounts the page — a
// dead session redirecting to login, a stray back button, a closed tab — used
// to take it with it. These keep a local draft so it survives, and clear it
// the moment the server has the text.
//
// Lives in its own module rather than inside ExerciseViewer so AuthContext can
// clear drafts on sign-out without pulling the lazy-loaded lesson pages into
// the main bundle.

const DRAFT_PREFIX = 'exercise-draft:';

export function draftKeyFor(lessonId) {
  return `${DRAFT_PREFIX}${lessonId}`;
}

// Storage can throw (private browsing, quota, disabled). Drafts are a safety
// net, never something the viewer depends on, so every failure is survivable.
export function readDraft(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeDraft(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* full or unavailable — nothing useful to do */
  }
}

export function clearDraft(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* nothing to do */
  }
}

// Called on sign-out so one student's writing can't be read by the next person
// to use a shared machine. Not called on session expiry — that's involuntary,
// and the draft is exactly what we're trying to save.
export function clearAllExerciseDrafts() {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(DRAFT_PREFIX))
      .forEach((k) => localStorage.removeItem(k));
  } catch {
    /* nothing to do */
  }
}
